import { formatUtils } from '@elotech/components';

export const formataCpfOuCnpj = (cpfCnpj: string = '') => {
  return formatUtils.formatCpfCnpj((cpfCnpj || '').toUpperCase());
};

export const retirarFormatacaoCnpjCpf = (cnpjCpf: string = '') => {
  return (cnpjCpf || '').toUpperCase().replace(/(\.|-|\/)*/g, '');
};
